import { Routes, Route, Navigate } from "react-router-dom";
import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

// Listing Route pages

// const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));
import Dashboard from "../pages/dashboard/Dashboard";

// const rtl = lazy(() => import("../pages/rtl/RTL"));
import Rtl from "../pages/rtl/RTL";

// apps
// (Skipping other imports for brevity)
import Kanban from "../pages/apps/Kanban";
import Todo from '../pages/apps/Todo'
import Tickets from "../pages/apps/Tickets";
import Chats from "../pages/apps/Chats";
import Email from "../pages/apps/Email";
import Calendar from "../pages/apps/Calendar";
import Gallery from "../pages/apps/Gallery";

// widgets
import Widget from "../pages/widgets/Widget";

// basic-ui
import Accordions from "../pages/basic-elements/Accordions";
import Buttons from "../pages/basic-elements/Buttons";
import Badges from "../pages/basic-elements/Badges";
import Breadcrumbs from "../pages/basic-elements/Breadcrumbs";
import Dropdowns from "../pages/basic-elements/Dropdowns";
import Modals from "../pages/basic-elements/Modals";
import Progressbar from "../pages/basic-elements/Progressbar";
import Pagination from "../pages/basic-elements/Pagination";
import Tabs from '../pages/basic-elements/Tabs'
import Typography from "../pages/basic-elements/Typography";
import Tooltips from "../pages/basic-elements/Tooltips";
import Popups from "../pages/basic-elements/Popups";

// advanced-ui
import Dragula from "../pages/advanced-elements/Dragula";
import Clipboard from "../pages/advanced-elements/Clipboard";
import Context from "../pages/advanced-elements/Contextmenu";
import Slider from '../pages/advanced-elements/Sliders'
import Carousel from "../pages/advanced-elements/Carousel";
import Loaders from "../pages/advanced-elements/Loaders";
import TreeView from "../pages/advanced-elements/TreeView";

// forms
import BasicForm from "../pages/form-elements/BasicForm";
import AdvancedForm from "../pages/form-elements/AdvancedForm";
import Validation from "../pages/form-elements/Validation";
import Wizard from "../pages/form-elements/Wizard";

// tables
import BasicTable from "../pages/tables/BasicTable";
import ReactTable from "../pages/tables/ReactTable";
import Datatable from "../pages/tables/DataTable";
import AGGrid from '../pages/tables/AGGrid'

// maps
import VectorMap from "../pages/maps/VectorMap";
import SimpleMap from "../pages/maps/SimpleMap";

import Notification from "../pages/notifications/Notifications";

// icons
import FlagIcons from "../pages/icons/FlagIcons";
import Fontawesome from "../pages/icons/Fontawesome";
import SimpleIcons from "../pages/icons/Simpleline";
import Feather from '../pages/icons/ReactFeather'
import Typicons from "../pages/icons/Typicons";

// editors
import TextEditor from "../pages/text-editor/TextEditor";
import CodeEditor from "../pages/code-editor/CodeEditor";

// charts
import Chartjs from "../pages/charts/Chartjs";
import Nivo from "../pages/charts/Nivo";
import Recharts from "../pages/charts/Recharts";
import AntV from "../pages/charts/AntV";
import Gauge from "../pages/charts/GaugeCharts";

// user-pages
import Login from "../pages/user-pages/Login";
import Login2 from "../pages/user-pages/Login-2";
import Register from "../pages/user-pages/Register";
import Register2 from "../pages/user-pages/Register-2";
import Lockscreen from "../pages/user-pages/Lockscreen";
import ForcePasswordChange from "../pages/user-pages/ForcePasswordChange";

// error-pages
import Error404 from "../pages/error-pages/404";
import Error500 from "../pages/error-pages/500";

// general-pages
import Blankpage from "../pages/general-pages/Blankpage";
import Landing from "../pages/general-pages/Landingpage";
import Profile from "../pages/general-pages/Profile";
import Faq from "../pages/general-pages/Faq";
import Faq2 from "../pages/general-pages/Faq-2";
import Newsgrid from "../pages/general-pages/Newsgrid";
import Timeline from "../pages/general-pages/Timeline";
import Searchresults from "../pages/general-pages/Searchresults";
import Portfolio from "../pages/general-pages/Portfolio";
import Userlisting from "../pages/general-pages/Userlisting";
import Customerlisting from "../pages/general-pages/Customerlisting";
import ZonesManager from "../pages/general-pages/ZonesManager";
import MasterDataConfig from '../pages/general-pages/MasterDataConfig';
import RoutePlanner from '../pages/general-pages/RoutePlanner';
import AgendaMonitor from '../pages/general-pages/AgendaMonitor';
import DispatchManager from '../pages/general-pages/DispatchManager';
import FaqManager from '../pages/general-pages/FaqManager';
import MerchandisingReports from '../pages/general-pages/MerchandisingReports';
import SellerAnalytics from '../pages/general-pages/SellerAnalytics';

// ecommerce
import Invoice from "../pages/ecommerce/Invoice";
import Pricing from "../pages/ecommerce/Pricing";
import Catalogue from "../pages/ecommerce/Catalogue";
import Project from "../pages/ecommerce/Project";
import Orders from "../pages/ecommerce/Orders";
import Documentation from "../pages/documentation/Documentation";
import ProtectedRoute from "../components/common/ProtectedRoute";

function AppRoutes() {
  const { token } = useContext(AuthContext);

  return (
      <Routes>
        {/* Redirección Inicial */}
        <Route path="/" element={<Navigate to={token ? "/dashboard" : "/user-pages/login"} replace />} />        
        
        {/* Vistas Principales y Operativas Protegidas */}
        <Route exact path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/general-pages/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/general-pages/user-listing" element={<ProtectedRoute><Userlisting /></ProtectedRoute>} />
        <Route path="/general-pages/customer-listing" element={<ProtectedRoute><Customerlisting /></ProtectedRoute>} />
        <Route path="/general-pages/zones-manager" element={<ProtectedRoute><ZonesManager /></ProtectedRoute>} />
        <Route path="/general-pages/master-data" element={<ProtectedRoute><MasterDataConfig /></ProtectedRoute>} />
        <Route path="/general-pages/faqs" element={<ProtectedRoute><FaqManager /></ProtectedRoute>} />
        <Route path="/general-pages/route-planner" element={<ProtectedRoute><RoutePlanner /></ProtectedRoute>} />
        <Route path="/general-pages/agenda-monitor" element={<ProtectedRoute><AgendaMonitor /></ProtectedRoute>} />
        <Route path="/general-pages/merchandising-reports" element={<ProtectedRoute><MerchandisingReports /></ProtectedRoute>} />
        <Route path="/general-pages/dispatch" element={<ProtectedRoute><DispatchManager /></ProtectedRoute>} />
        
        {/* Ventas y E-Commerce Protegidos */}
        <Route path="/ecommerce/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
        <Route path="/ecommerce/seller-analytics" element={<ProtectedRoute><SellerAnalytics /></ProtectedRoute>} />
        <Route path="/ecommerce/invoice" element={<ProtectedRoute><Invoice /></ProtectedRoute>} />
        <Route path="/ecommerce/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
        <Route path="/ecommerce/catalogue" element={<ProtectedRoute><Catalogue /></ProtectedRoute>} />
        <Route path="/ecommerce/project" element={<ProtectedRoute><Project /></ProtectedRoute>} />

        {/* Aplicaciones y Herramientas Protegidas */}
        <Route path="/apps/kanban" element={<ProtectedRoute><Kanban /></ProtectedRoute>} />
        <Route path="/apps/todo" element={<ProtectedRoute><Todo /></ProtectedRoute>} />
        <Route path="/apps/ticket" element={<ProtectedRoute><Tickets /></ProtectedRoute>} />
        <Route path="/apps/chat" element={<ProtectedRoute><Chats /></ProtectedRoute>} />
        <Route path="/apps/email" element={<ProtectedRoute><Email /></ProtectedRoute>}  />
        <Route path="/apps/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
        <Route path="/apps/gallery" element={<ProtectedRoute><Gallery /></ProtectedRoute>} />
        <Route exact path="/widgets" element={<ProtectedRoute><Widget /></ProtectedRoute>} />
        <Route exact path="/notification" element={<ProtectedRoute><Notification /></ProtectedRoute>} />

        {/* Componentes de UI y Formularios Protegidos */}
        <Route path="/basic-ui/accordions" element={<ProtectedRoute><Accordions /></ProtectedRoute>} />
        <Route path="/basic-ui/buttons" element={<ProtectedRoute><Buttons /></ProtectedRoute>} />
        <Route path="/basic-ui/badges" element={<ProtectedRoute><Badges /></ProtectedRoute>} />
        <Route path="/basic-ui/breadcrumbs" element={<ProtectedRoute><Breadcrumbs /></ProtectedRoute>} />
        <Route path="/basic-ui/dropdowns" element={<ProtectedRoute><Dropdowns /></ProtectedRoute>} />
        <Route path="/basic-ui/modal" element={<ProtectedRoute><Modals /></ProtectedRoute>} />
        <Route path="/basic-ui/progressbar" element={<ProtectedRoute><Progressbar /></ProtectedRoute>} />
        <Route path="/basic-ui/pagination" element={<ProtectedRoute><Pagination /></ProtectedRoute>} />
        <Route path="/basic-ui/tabs" element={<ProtectedRoute><Tabs /></ProtectedRoute>} />
        <Route path="/basic-ui/typography" element={<ProtectedRoute><Typography /></ProtectedRoute>} />
        <Route path="/basic-ui/tooltips" element={<ProtectedRoute><Tooltips /></ProtectedRoute>} />
        <Route path="/basic-ui/popups" element={<ProtectedRoute><Popups /></ProtectedRoute>} />
        <Route path="/advanced-ui/dragula" element={<ProtectedRoute><Dragula /></ProtectedRoute>} />
        <Route path="/advanced-ui/clipboard" element={<ProtectedRoute><Clipboard /></ProtectedRoute>} />
        <Route path="/advanced-ui/context" element={<ProtectedRoute><Context /></ProtectedRoute>} />
        <Route path="/advanced-ui/slider" element={<ProtectedRoute><Slider /></ProtectedRoute>} />
        <Route path="/advanced-ui/carousel" element={<ProtectedRoute><Carousel /></ProtectedRoute>} />
        <Route path="/advanced-ui/loaders" element={<ProtectedRoute><Loaders /></ProtectedRoute>} />
        <Route path="/advanced-ui/treeview" element={<ProtectedRoute><TreeView /></ProtectedRoute>} />
        <Route path="/form-elements/basic-elements" element={<ProtectedRoute><BasicForm /></ProtectedRoute>} />
        <Route path="/form-elements/advanced-elements" element={<ProtectedRoute><AdvancedForm /></ProtectedRoute>} />
        <Route path="/form-elements/validation" element={<ProtectedRoute><Validation /></ProtectedRoute>} />
        <Route path="/form-elements/wizard" element={<ProtectedRoute><Wizard /></ProtectedRoute>} />
        <Route path="/tables/basic-table" element={<ProtectedRoute><BasicTable /></ProtectedRoute>} />
        <Route path="/tables/react-table" element={<ProtectedRoute><ReactTable /></ProtectedRoute>} />
        <Route path="/tables/data-table" element={<ProtectedRoute><Datatable /></ProtectedRoute>} />
        <Route path="/tables/ag-grid" element={<ProtectedRoute><AGGrid /></ProtectedRoute>} />
        <Route path="/maps/pigeon-map" element={<ProtectedRoute><VectorMap /></ProtectedRoute>} />
        <Route path="/maps/simple-map" element={<ProtectedRoute><SimpleMap /></ProtectedRoute>} />
        <Route path="/icons/flag-icon" element={<ProtectedRoute><FlagIcons /></ProtectedRoute>} />
        <Route path="/icons/font-awesome" element={<ProtectedRoute><Fontawesome /></ProtectedRoute>} />
        <Route path="/icons/simple-line" element={<ProtectedRoute><SimpleIcons /></ProtectedRoute>} />
        <Route path="/icons/feather" element={<ProtectedRoute><Feather /></ProtectedRoute>} />
        <Route path="/icons/typicons" element={<ProtectedRoute><Typicons /></ProtectedRoute>} />
        <Route path="/editors/text-editor" element={<ProtectedRoute><TextEditor /></ProtectedRoute>} />
        <Route path="/editors/code-editor" element={<ProtectedRoute><CodeEditor /></ProtectedRoute>} />
        <Route path="/charts/chart-js" element={<ProtectedRoute><Chartjs /></ProtectedRoute>} />
        <Route path="/charts/nivo" element={<ProtectedRoute><Nivo /></ProtectedRoute>} />
        <Route path="/charts/recharts" element={<ProtectedRoute><Recharts /></ProtectedRoute>} />
        <Route path="/charts/antv" element={<ProtectedRoute><AntV /></ProtectedRoute>} />
        <Route path="/charts/gauge" element={<ProtectedRoute><Gauge /></ProtectedRoute>} />

        {/* Páginas Generales Protegidas */}
        <Route path="/general-pages/blank-page" element={<ProtectedRoute><Blankpage /></ProtectedRoute>} />
        <Route path="/general-pages/2faq" element={<ProtectedRoute><Faq2 /></ProtectedRoute>} />
        <Route path="/general-pages/news-grid" element={<ProtectedRoute><Newsgrid /></ProtectedRoute>} />
        <Route path="/general-pages/faq" element={<ProtectedRoute><Faq /></ProtectedRoute>} />
        <Route path="/general-pages/search-results" element={<ProtectedRoute><Searchresults /></ProtectedRoute>} />
        <Route path="/general-pages/timeline" element={<ProtectedRoute><Timeline /></ProtectedRoute>} />
        <Route path="/general-pages/portfolio" element={<ProtectedRoute><Portfolio /></ProtectedRoute>} />
        <Route exact path="/documentation" element={<ProtectedRoute><Documentation /></ProtectedRoute>} />

        {/* Rutas Públicas (Sin Autenticación) */}
        <Route exact path="/rtl" element={<Rtl />} />
        <Route path="/user-pages/login" element={token ? <Navigate to="/dashboard" replace /> : <Login />} />
        <Route path="/user-pages/login-2" element={token ? <Navigate to="/dashboard" replace /> : <Login2 />} />
        <Route path="/user-pages/register" element={token ? <Navigate to="/dashboard" replace /> : <Register />} />
        <Route path="/user-pages/register-2" element={token ? <Navigate to="/dashboard" replace /> : <Register2 />} /> 
        <Route path="/user-pages/lock-screen" element={<Lockscreen />} />
        <Route path="/user-pages/force-password-change" element={<ForcePasswordChange />} />
        <Route path="/actualizar-clave-inicial" element={<ForcePasswordChange />} />
        <Route path="/general-pages/landing" element={<Landing />} />
        <Route path="/error-pages/404" element={<Error404 />} />
        <Route path="/error-pages/500" element={<Error500 />} />

        {/* Fallback 404 */}
        <Route path="*" element={<Navigate to="/error-pages/404" replace />} />
      </Routes>
  );
}

export default AppRoutes;
